import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { getTranslation, translations } from "./translations";

const STORAGE_KEY = "trustherhome:lang";
const SUPPORTED = ["en", "es"];

const LanguageContext = createContext({
    lang: "en",
    setLang: () => {},
    toggleLang: () => {},
    t: (k) => k,
});

export function LanguageProvider({ children }) {
    const [lang, setLangState] = useState(() => {
        if (typeof window === "undefined") return "en";
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored && SUPPORTED.includes(stored)) return stored;
        const nav = (window.navigator.language || "en").slice(0, 2).toLowerCase();
        return SUPPORTED.includes(nav) ? nav : "en";
    });

    useEffect(() => {
        if (typeof window !== "undefined") {
            window.localStorage.setItem(STORAGE_KEY, lang);
            document.documentElement.lang = lang;
        }
    }, [lang]);

    const setLang = useCallback((next) => {
        if (SUPPORTED.includes(next)) setLangState(next);
    }, []);

    const toggleLang = useCallback(() => {
        setLangState((cur) => (cur === "en" ? "es" : "en"));
    }, []);

    const t = useCallback((key) => getTranslation(lang, key), [lang]);

    const value = useMemo(
        () => ({ lang, setLang, toggleLang, t, supported: SUPPORTED, translations }),
        [lang, setLang, toggleLang, t]
    );

    return (
        <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
    );
}

export function useTranslation() {
    return useContext(LanguageContext);
}
